<template>
    <div class="loginMen">
        <navTop :isLogin="1" titile="相君科技平台用户首页"></navTop>
        <div class="newLomk">
            <div class="loginMen_all">
                <div class="loginUser">
                    <div class="coverage">
                        <div class="cov_left">
                            <div class="btnRu">快捷入口</div>
                            <el-collapse accordion v-for="(item,index) in bandner" :key="index"
                                         @change="handlCheckMenu(index)">
                                <el-collapse-item>
                                    <template slot="title">
                                        <div :class="bandnerActive == index ? 'btnSin' : ''">
                                            {{item.title}}
                                        </div>
                                    </template>
                                    <div class="vip-down" @click="handlCheckTwoMenu(newIndex)"
                                         v-for="(newItem,newIndex) in item.list"
                                         :key="newIndex" :class="bandnerTwoActive == newIndex ? 'vip-downActive' : ''">
                                        {{newItem.text}}
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                        <div class="cov_right">
                            <div class="user">
                                <div class="user_top">
                                    <div class="user_header">
                                        <!-- <img src="../../../assets/logo.png" /> -->
                                        <img :src="$global.Local + $store.store.state.userData.headImg"
                                             v-if="$store.store.state.userData.headImg"/>
                                        <img src="../../../assets/logo.png" v-else/>
                                    </div>
                                    <div class="user_detal">
                                        <!-- {{$store.store.state.userData}} -->
                                        <div class="top" v-if="!$store.store.state.userData.type">
                                            未认证 <span @click="handlAuthen">去认证</span>
                                        </div>
                                        <div class="top" v-else>
                                          <div class="top" v-if="$store.store.state.userData.type === '1'">
                                            <span v-if="$store.store.state.userData.passStatus == 0">审核中</span>
                                            <span v-if="$store.store.state.userData.passStatus == 1">个人已认证，点击企业认证</span>
                                            <span v-if="$store.store.state.userData.passStatus == 2">审核未通过，重新认证</span>
                                          </div>
                                          <div class="top" v-if="$store.store.state.userData.type === '2'">
                                            企业认证
                                            <span v-if="$store.store.state.userData.passStatus === '0'">审核中</span>
                                            <span v-if="$store.store.state.userData.passStatus === '1'">已认证</span>
                                            <span v-if="$store.store.state.userData.passStatus === '2'" @click="handlAuthen">审核未通过，重新认证</span>
                                          </div>
                                        </div>


                                        <!-- <div class="top"
                                             v-if="$store.store.state.userData.passStatus == 0 && $global.webData.type">
                                            审核中
                                        </div>
                                        <div class="top" v-else-if="$store.store.state.userData.passStatus == 1">

                                            <div v-if="$store.store.state.userData.type == 1">
                                                个人已认证<span @click="handlAuthen">点击认证企业</span>
                                            </div>
                                            <div v-if="$store.store.state.userData.type == 2">
                                                 <span>已认证</span>
                                            </div>

                                        </div>
                                        <div class="top" v-else>
                                            未认证 <span @click="handlAuthen">去认证</span>
                                        </div> -->

                                        <div class="bom">
                                            用户账号：{{email}}<br>
                                            <!-- <span v-if="cert.length > 4">证书: {{cert}}</span>
                                             <span v-else>证书有效期：{{cert}}天</span> -->

                                            <td v-if="cert.uselimitOrtimelimt">证书：{{cert.uselimitOrtimelimt}}</td>
                                            <td v-else-if="cert.timeLimit">证书有效期：{{cert.timeLimit}}天</td>
                                            <td v-else-if="cert.useLimit">证书有效期：{{cert.useLimit}}次</td>
                                        </div>
                                    </div>
                                </div>
                                <div class="user_bom">
                                    <div class="btn" :class="userActive == index ? 'btnActive' : ''"
                                         v-for="(item,index) in detalList"
                                         :key='index' @click="userActive = index">
                                        <div class="title">{{item.title}}</div>
                                        <div class="num">{{item.num}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bomTitle">最新记录</div>
                    <div class="table">
                        <el-table :data="tableData">
                            <el-table-column prop="title" label="合同标题" align="center">
                            </el-table-column>
                            <el-table-column prop="ct" label="更新时间"  align="center">
                            </el-table-column>
                            <el-table-column label="合同操作"  align="center">
                                <template slot-scope="scope">
                                    <div class="tableBtn" @click="handlCheckLook(scope.row)">查看详情</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <navAdv/>
        <nav-bom></nav-bom>
    </div>
</template>

<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'
    import navAdv from '../../nav/nav-adv.vue'  
    export default {
        components: {
            navTop,
            navBom,
            navAdv
        },
        data() {
            return {
                passStatus: 0,
                tableData: [],
                bandnerActive: null,
                userDialogVisible: false,
                email: '',
                isRenZheng: '',
                bandnerTwoActive: null,
                cert: '',
                idCard: {
                    one: '',
                    two: '',
                    three: '',
                    four: ''
                },
                bandner: [{
                    title: '合同签署',
                    list: [
                        {
                            text: '立即签署合同',
                        },
                        {
                            text: '合同模板',
                        },
                        {
                            text: '我的模板',
                        },
                    ]
                },
                    {
                        title: '签章验证'
                    },
                    // {
                    //   title: '证书续费'
                    // },
                    {
                      title: 'UKey'
                    },
                    {
                        title: '会员中心'
                    },
                ],
                userActive: 2,
                detalList: [
                    {
                        title: '起草合同',
                        num: 0
                    },
                    {
                        title: '已签订合同',
                        num: 0
                    },
                    {
                        title: '我的模板数量',
                        num: 0
                    },
                    {
                        title: '等待他人签署',
                        num: 0
                    },
                ]
            }
        },
        created() {
            this.handltemplNum();
            this.passStatus = localStorage.getItem('passState');
            this.email = this.$store.store.state.userData.email;
            // this.isRenZheng = this.$store.store.state.userData.state;
            this.isRenZheng = this.$global.webData.type;
        },
        mounted() {

            //this.$router.go(0);

            this.handlTempList();
        },
        methods: {
            isIndexOf(value) {
                alert(value)
                if (value.indexOf("未购买") != -1) {
                    return true
                } else {
                    return false
                }
            },
            handlCheckLook(row) {

                this.$router.push({
                    name: 'signContract',
                    params: {
                        yes: 1,
                        pdf: row.contactPath,
                    }
                })

                // this.$router.push({
                //   name: 'detalContract',
                //   params: {
                //     id: row.id,
                //     isMy: 1,
                //     isLook: 1,
                //     isSign: 1,
                //     pdf: row.contactPath,
                //     title: row.title,
                //     list: 1 //区分从哪里进入
                //   }
                // })

                // if (row.signState == 0) {
                //     this.$router.push({
                //         name: 'detalContract',
                //         params: {
                //             id: row.id,
                //             isMy: 1,
                //             isLook: 0,
                //             title: row.title,
                //             list: 1 //区分从哪里进入
                //         }
                //     })
                // } else if (row.signState == 3 || row.signState == 5) {
                //     this.$router.push({
                //         name: 'signContract',
                //         params: {
                //             yes: 1,
                //             pdf: row.contactPath,
                //         }
                //     })
                // } else {
                //     this.$router.push({
                //         name: 'detalContract',
                //         params: {
                //             id: row.id,
                //             isMy: 1,
                //             isLook: 1,
                //             isSign: row.signState,
                //             pdf: row.contactPath,
                //             title: row.title,
                //             list: 1 //区分从哪里进入
                //         }
                //     })
                // }

            },
            handlTempList() {
                let _this = this;
                this.tableData = [];
                let param = new FormData();
                param.append('token', _this.$global.token);
                _this.api.getContactList(param).then(res => {
                    console.log(res);
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[i].delFlag == 1 && _this.tableData.length <= 3) {
                            _this.tableData.push(res.data[i])
                        }
                    }
                })
            },
            handlCheckMenu(index) {
                if (!this.$global.webData.type) {
                    this.$router.push('authen');
                    return
                } else {
                    this.bandnerActive = index;
                    this.$router.push({
                        path: '/navLeft',
                        query: {
                            active: index
                        }
                    })
                }

            },
            handlCheckTwoMenu(index) {
                this.bandnerTwoActive = index;
            },
            handlAuthen() {
                this.$router.push('authen');
            },
            handltemplNum() {
                let _this = this;
                let param = new FormData();
                param.append('token', _this.$global.token);
                _this.api.getStatistics(param).then(res => {
                    console.log(res);
                    _this.detalList[1].num = res.data.success;
                    _this.detalList[0].num = res.data.drafting;
                    _this.detalList[2].num = res.data.template;
                    _this.detalList[3].num = res.data.wait;
                    _this.cert = res.data;
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    /deep/ .el-table__body tr:hover > td {
        background-image: linear-gradient(#1e6eee 0%, #109ee7 50%, #01cee0 100%);
        color: #fff;
    }

    /deep/ .el-table__header {
        width: auto !important;
    }

    /deep/ .el-table__body {
        width: auto !important;
    }

    /deep/ .el-table__body tr > td {
        font-size: 18px;
    }

    /deep/ .el-collapse-item__arrow {
        display: none;
    }

    /deep/ .el-collapse-item__content {
        padding: 0;
    }

    /deep/ .el-collapse {
        border: 1px solid #EBEEF5;
    }

    /deep/ .el-collapse-item__header {
        width: auto;
        height: 81px;
        background-color: #fff;
        text-align: center;
        letter-spacing: 1px;
        color: #333333;
        font-size: 24px;
        @row();
    }

    /deep/ .el-collapse-item__header:hover {
        background-image: linear-gradient(270deg,
        #1e6eee 0%,
        #109ee7 50%,
        #01cee0 100%),
        linear-gradient(#000000,
        #000000);
        background-blend-mode: normal,
        normal;
        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
        color: #fff;
    }


    /deep/ .el-table .cell {
        @row();
    }

    /deep/ .el-table th {
        background-color: #f5f5f5;
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
        height: 60px;
    }

    .loginMen {
        width: @a;
        height: @a;

        .newLomk {
            width: @a;
            height: auto;
            @row();

            .loginMen_all {
                width: 1410px;
                height: 930px;
                // @row();
                padding: 2% 0;

                .loginUser {
                    width: @a;
                    height: 830px;

                    .coverage {
                        width: @a;
                        height: auto;
                        display: @flex;

                        .cov_left {
                            width: 280px;
                            height: @a;

                            .btnRu {
                                width: 280px;
                                height: 110px;
                                line-height: 110px;
                                text-align: center;
                                background-color: #f5f5f5;
                                letter-spacing: 2px;
                                color: #333333;
                                font-family: MicrosoftYaHei-Bold;
                                font-size: 30px;
                                font-weight: normal;
                                font-stretch: normal;
                            }

                            .vip-down {
                                width: auto;
                                height: 61px;
                                text-align: center;
                                line-height: 61px;
                                background-color: #f5f5f5;
                                border: solid 1px #aaaaaa;
                                font-size: 18px;
                                letter-spacing: 1px;
                                color: #333333;
                                margin: -1px;
                                cursor: pointer;
                            }

                            .vip-downActive {
                                background-color: #dddddd;
                            }

                            .btnSin {
                                width: 280px;
                                height: 80px;
                                line-height: 80px;
                                text-align: center;
                                background-image: linear-gradient(270deg,
                                #1e6eee 0%,
                                #109ee7 50%,
                                #01cee0 100%),
                                linear-gradient(#000000,
                                #000000);
                                background-blend-mode: normal,
                                normal;
                                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                                cursor: pointer;
                                color: #fff !important;
                            }

                            .btnVip {
                                width: 280px;
                                height: 81px;
                                line-height: 81px;
                                text-align: center;
                                background-color: #f2f2f2;
                                border: solid 1px #aaaaaa;
                                font-family: MicrosoftYaHei;
                                font-size: 24px;
                                font-weight: normal;
                                font-stretch: normal;
                                letter-spacing: 1px;
                                color: #333333;
                                cursor: pointer;
                            }
                        }

                        .cov_right {
                            width: 1060px;
                            height: 390px;
                            margin-left: 4%;

                            .user {
                                width: @a;
                                height: 120px;

                                .user_top {
                                    width: @a;
                                    height: 120px;
                                    display: @flex;

                                    .user_header {
                                        width: 120px;
                                        height: 120px;
                                        border-radius: 50%;
                                        overflow: hidden;

                                        img {
                                            width: @a;
                                            height: @a;
                                            object-fit: cover;
                                        }
                                    }

                                    .user_detal {
                                        width: 500px;
                                        height: @a;
                                        margin-left: 30px;

                                        .top {
                                            margin-top: 14px;
                                            width: @a;
                                            height: 24px;
                                            font-family: MicrosoftYaHei-Bold;
                                            font-size: 24px;
                                            font-weight: normal;
                                            font-stretch: normal;
                                            letter-spacing: 1px;
                                            color: #333333;

                                            span {
                                                padding: 1px 7px;
                                                background-color: #f2f2f2;
                                                border-radius: 10px;
                                                border: solid 1px #aaaaaa;
                                                font-size: 18px;
                                                color: #333333;
                                                cursor: pointer;
                                            }
                                        }

                                        .bom {
                                            margin-top: 22px;
                                            width: @a;
                                            height: 24px;
                                            font-family: MicrosoftYaHei;
                                            font-size: 18px;
                                            font-weight: normal;
                                            font-stretch: normal;
                                            line-height: 30px;
                                            letter-spacing: 0px;
                                            color: #333333;
                                        }
                                    }
                                }

                                .user_bom {
                                    width: 1060px;
                                    height: 220px;
                                    display: @flex;
                                    margin-top: 50px;

                                    .btn:first-child {
                                        margin-left: 0;
                                    }

                                    .btnActive {
                                        background-image: linear-gradient(270deg,
                                        #1e6eee 0%,
                                        #109ee7 50%,
                                        #01cee0 100%),
                                        linear-gradient(#000000,
                                        #000000);
                                        background-blend-mode: normal,
                                        normal;
                                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                                        color: #fff !important;
                                    }

                                    .btn {
                                        margin-left: 60px;
                                        width: 220px;
                                        height: 220px;
                                        background-color: #f2f2f2;
                                        border: solid 1px #aaaaaa;
                                        border-radius: 50%;
                                        color: #333333;
                                        cursor: pointer;

                                        .title {
                                            width: @a;
                                            margin-top: 79px;
                                            text-align: center;
                                            height: 24px;
                                            font-family: MicrosoftYaHei;
                                            font-size: 24px;
                                            font-weight: normal;
                                            font-stretch: normal;
                                            letter-spacing: 1px;
                                        }

                                        .num {
                                            width: @a;
                                            margin-top: 16px;
                                            text-align: center;
                                            height: 35px;
                                            font-family: MicrosoftYaHei-Bold;
                                            font-size: 36px;
                                            font-weight: normal;
                                            font-stretch: normal;
                                            letter-spacing: 2px;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .bomTitle {
                        width: @a;
                        height: 24px;
                        font-family: MicrosoftYaHei-Bold;
                        font-size: 24px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #333333;
                        margin-top: 47px;
                        /* test */
                        // padding-left: 25%;
                    }

                    .table {
                        width: @a;
                        height: 290px;
                        margin-top: 38px;

                        .tableBtn {
                            width: 100px;
                            height: 30px;
                            line-height: 30px;
                            background-color: #f2f2f2;
                            border-radius: 15px;
                            border: solid 1px #aaaaaa;
                            display: flex;
                            justify-content: center;
                            cursor: pointer;
                            color: #333333 !important;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/menu/loginMenu.vue